import { CustomEditor } from '../../../../models/slate-editor';
import { Editor, Element, Node, Path, Text, Transforms } from 'slate';

export const withNormalization = (editor: CustomEditor): CustomEditor => {
  const { normalizeNode } = editor;

  editor.normalizeNode = entry => {
    const [node, path] = entry;
    // remove double spaces in text
    if (Element.isElement(node) && node.type === 'paragraph') {
      for (const [child, childPath] of Array.from(Node.children(editor, path))) {
        const doubleSpaces = / {2,}/g;
        if (Text.isText(child) && child.text && doubleSpaces.test(child.text)) {
          const oldText = child.text;
          const newText = oldText.replace(doubleSpaces, ' ');
          const { selection } = editor;
          let newSelection = selection;

          // If the selection is within the affected text node, adjust it.
          if (
            selection &&
            Path.equals(selection.anchor.path, childPath) &&
            Path.equals(selection.focus.path, childPath)
          ) {
            const anchorOffset = selection.anchor.offset;
            // Get the text before the anchor and see how it normalizes.
            const textBefore = oldText.slice(0, anchorOffset);
            const normalizedTextBefore = textBefore.replace(doubleSpaces, ' ');
            // Calculate how many characters were removed.
            const offsetDiff = normalizedTextBefore.length - textBefore.length;

            newSelection = {
              anchor: { ...selection.anchor, offset: selection.anchor.offset + offsetDiff },
              focus: { ...selection.focus, offset: selection.focus.offset + offsetDiff }
            };
          }

          Editor.withoutNormalizing(editor, () => {
            // Replace the text at childPath with the normalized version.
            Transforms.insertText(editor, newText, { at: childPath });
            // If we adjusted the selection, restore it.
            if (newSelection) {
              Transforms.select(editor, newSelection);
            }
          });
          return;
        }
      }
    }

    normalizeNode(entry);
  };

  return editor;
};
